import { lazy, Suspense } from "react";
import { Route, Navigate } from "react-router-dom";
import ProtectedRoute from "../components/common/ProtectedRoute";
import PageLoader from "../components/common/PageLoader";

const AdminLayout = lazy(() => import("../components/admin/AdminLayout"));
const AdminDashboard = lazy(() => import("../components/pages/admin/AdminDashboard"));
const AdminCompetitionUsers = lazy(() => import("../components/pages/admin/AdminCompetitionUsers"));
const AdminUsers = lazy(() => import("../components/pages/admin/AdminUsers"));
const AdminUserDetails = lazy(() => import("../components/pages/admin/AdminUserDetails"));
const AdminStores = lazy(() => import("../components/pages/admin/AdminStores"));
const AdminStoreDetails = lazy(() => import("../components/pages/admin/AdminStoreDetails"));
const AdminProducts = lazy(() => import("../components/pages/admin/AdminProducts"));
const AdminPendingProducts = lazy(() => import("../components/pages/admin/AdminPendingProducts"));
const AdminFlaggedProducts = lazy(() => import("../components/pages/admin/AdminFlaggedProducts"));
const AdminOrders = lazy(() => import("../components/pages/admin/AdminOrders"));
const AdminPendingOrders = lazy(() => import("../components/pages/admin/AdminPendingOrders"));
const AdminRefunds = lazy(() => import("../components/pages/admin/AdminRefunds"));
const AdminTransactions = lazy(() => import("../components/pages/admin/AdminTransactions"));
const AdminCommission = lazy(() => import("../components/pages/admin/AdminCommission"));
const AdminPayouts = lazy(() => import("../components/pages/admin/AdminPayouts"));
const AdminAnalytics = lazy(() => import("../components/pages/admin/AdminAnalytics"));
const AdminCategories = lazy(() => import("../components/pages/admin/AdminCategories"));
const AdminBanners = lazy(() => import("../components/pages/admin/AdminBanners"));
const AdminCoupons = lazy(() => import("../components/pages/admin/AdminCoupons"));
const AdminTaxes = lazy(() => import("../components/pages/admin/AdminTaxes"));
const AdminSettings = lazy(() => import("../components/pages/admin/AdminSettings"));

// Page-level Suspense AdminLayout ke andar hai (Outlet ke around)
const AdminRoutes = () => (
  <Route
    path="/admin"
    element={
      <ProtectedRoute allowedRoles={["superadmin"]}>
        <Suspense fallback={<PageLoader />}>
          <AdminLayout />
        </Suspense>
      </ProtectedRoute>
    }
  >
    <Route index element={<Navigate to="/admin/dashboard" replace />} />

    <Route path="dashboard" element={<AdminDashboard />} />
    <Route path="analytics" element={<AdminAnalytics />} />

    <Route path="users" element={<AdminUsers />} />
    <Route path="users/:id" element={<AdminUserDetails />} />
    <Route path="competition-users" element={<AdminCompetitionUsers />} />
    <Route path="competition-users/:id" element={<AdminCompetitionUsers />} />

    <Route path="stores" element={<AdminStores />} />
    <Route path="stores/:id" element={<AdminStoreDetails />} />

    <Route path="products/all" element={<AdminProducts />} />
    <Route path="products/pending" element={<AdminPendingProducts />} />
    <Route path="products/flagged" element={<AdminFlaggedProducts />} />

    <Route path="orders/all" element={<AdminOrders />} />
    <Route path="orders/pending" element={<AdminPendingOrders />} />
    <Route path="refunds" element={<AdminRefunds />} />

    <Route path="transactions" element={<AdminTransactions />} />
    <Route path="commission" element={<AdminCommission />} />
    <Route path="payouts" element={<AdminPayouts />} />

    <Route path="categories" element={<AdminCategories />} />
    <Route path="banners" element={<AdminBanners />} />
    <Route path="coupons" element={<AdminCoupons />} />
    <Route path="taxes" element={<AdminTaxes />} />
    <Route path="settings" element={<AdminSettings />} />
  </Route>
);

export default AdminRoutes;
